import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress.jsx"
import { CustomAvatar } from "../../Components/CustomAvatar.jsx"
import { createAsesor } from "../../endpoints.js"
import Swal from "sweetalert2";
import Dropdown from './Dropdown';
import { uploadToS3 } from "../../endpoints.js"

const CreateAsesor =
  ({
    stopPropagation,
    closeModalCreateAsesor,
    getAsesores,
    setAsesores
  }) => {

    const localidades = [
      "La Plata",
      "Mendoza",

    ]
    const [localidad, setLocaldiad] = useState("La Plata");
    const [editarAsesor, setEditarAsesor] = useState(false);
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({
      nombre: '',
      apellido: '',
      telefono: '',
      email: '',
      password: '',
      partido_localidad: ''
    });
    useEffect(() => {

      console.log(localidad, "localidad")
    }, [localidad]);
    const [formData, setFormData] = useState({
      nombre: '',
      apellido: '',
      telefono: '',
      email: '',
      password: '',
      imagen_profile: '',
      partido_localidad: localidad,
      type: 'Asesor'

    });

    const checkName = () => {
      if (!formData?.nombre?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          nombre: 'El nombre es obligatorio',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          nombre: '',
        }));
      }
    }

    const checkApellido = () => {
      if (!formData?.apellido?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          apellido: 'El apellido es obligatorio',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          apellido: '',
        }));
      }
    }

    const checkEmail = () => {
      if (!formData?.email?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: 'El email es obligatorio',
        }));
      } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: 'El email ingresado no es válido',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: '',
        }));
      }
    }

    const checkPassword = () => {
      if (!formData?.password?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: 'La contraseña es obligatoria',
        }));
      } else if (formData.password.length < 8) {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: 'La contraseña debe tener al menos 8 caracteres',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: '',
        }));
      }
    }

    const checkTelefono = () => {
      if (!formData?.telefono?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: 'El teléfono es obligatorio',
        }));
      } else if (!/^\d{10}$/.test(formData.telefono)) {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: 'El teléfono debe contener 10 números',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: '',
        }));
      }
    }
    const checkLocalidad = () => {
      if (!formData?.partido_localidad?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          partido_localidad: 'Campo obligatorio',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          partido_localidad: '',
        }));
      }
    }


    const handleCancelar = () => {

      closeModalCreateAsesor();
    };
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };


    const handleChangeImg = async (e) => {
      setLoader(true);
      const selectedFile = e.target.files[0];

      const formData = new FormData();
      formData.append('file', selectedFile);
      uploadToS3(formData).then((res) => {
        if (res.status === 200) {

          console.log(res.data.photoUrl)
          setFormData(prevErrors => ({
            ...prevErrors,
            imagen_profile: res.data.photoUrl,
          }));

          setLoader(false);
        } else {
          setLoader(false);
          Swal.fire({
            icon: "error",
            title: "Ocurrio un error al subir la imagen",
            confirmButtonText: "Listo",
            confirmButtonColor: "#6f120f",
          });
        }

      })

    };



    const checkErrors = () => {
      checkEmail()
      checkPassword()
      checkTelefono()
      checkApellido()
      checkName()
      checkLocalidad()
    }

    const createAsesorSubmit = async () => {
      checkErrors()
      if (
        errors.nombre === '' &&
        errors.apellido === '' &&
        errors.telefono === '' &&
        errors.email === '' &&
        errors.password === '' &&
        errors.partido_localidad === ''
      ) {
        createAsesor({
          name: formData.nombre,
          lastname: formData.apellido,
          email: formData.email,
          photo: formData.imagen_profile,
          password: formData.password,
          userType: formData.type,
          phone: formData.telefono,
          partido_localidad: localidad
        }).then((res) => {
          if (res.status === 200) {
            closeModalCreateAsesor()
            setAsesores([])
            getAsesores()
            Swal.fire({
              icon: "success",
              title: "El asesor fue creado con exito",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Usuario ya registrado",
              confirmButtonText: "Listo",
              confirmButtonColor: "#6f120f",
            });
          }
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Revise los campos y vuevla a intentar",
          confirmButtonText: "Listo",
          confirmButtonColor: "#6f120f",
        });
        console.log(errors)
      }
    }

    return (
      <ModalWrapper onClick={handleCancelar}>
        <DivColumn onClick={stopPropagation}>
          <Text1>
            Formulario de Creación de Asesor
          </Text1>
          <DivRowContent>

            <ContImg>
              {loader ? (
                <ConLoader>
                  <CustomCircularProgress size={23} />
                </ConLoader>
              ) : null}
              <label htmlFor="update-image-profile">
                <CustomAvatar loader={loader} avatarStyle={100} srcImage={formData.imagen_profile} />
                <InputImage
                  type="file"
                  id="update-image-profile"
                  name="imagen_profile"
                  accept=".jpeg, .png, .jpg"
                  onChange={(e) => handleChangeImg(e)}

                />
              </label>

            </ContImg>
            <ContentFormGrid>

              <FormGroup>


                <Label htmlFor="nombre">Nombre *</Label>
                <Input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder='Ingrese nombre'
                  onBlur={checkName}
                />
                {errors.nombre && <ErrorMessage>{errors.nombre}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="apellido">Apellido *</Label>
                <Input
                  type="text"
                  id="apellido"
                  name="apellido"
                  value={formData.apellido}
                  onChange={handleChange}
                  placeholder='Ingrese apellido'
                  onBlur={checkApellido}
                />
                {errors.apellido && <ErrorMessage>{errors.apellido}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="telefono">Telefono *</Label>
                <Input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder='Ingrese telefono'
                  onBlur={checkTelefono}
                />
                {errors.telefono && <ErrorMessage>{errors.telefono}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="partido_localidad">Sucursal *</Label>
                <Dropdown
                  Containerwidth={'100%'}
                  options={localidades}
                  selectedOption={localidad}
                  setSelectedOption={setLocaldiad}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="email">Email *</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='Ingrese email'
                  onBlur={checkEmail}
                />
                {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="password">Contraseña *</Label>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder='Ingrese contraseña'
                  onBlur={checkPassword}
                />
                {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
              </FormGroup>
            </ContentFormGrid>
          </DivRowContent>

          <Text2>
            {"Los campos que cuenta con un * son obligatorios."}
          </Text2>


          <BtnCrearAsesor onClick={createAsesorSubmit}>
            CREAR ASESOR
          </BtnCrearAsesor>
        </DivColumn>
      </ModalWrapper>

    );
  };

export default CreateAsesor;
const DivRowContent = styled.div`
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  gap:16px;
  width: -webkit-fill-available;
  @media only screen and (min-width:0px) and (max-width:1100px){
    flex-direction:column;
 }
`;
const InputImage = styled.input`
  display: none;
`;
const ConLoader = styled.div`
  position: absolute;
  z-index: 5;
  left: auto;
  top: auto;
  // border:solid 1px red;
`;
const ConBtns = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    gap: 16px;
  }
  @media only screen and (min-width: 481px) and (max-width: 966px) {
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    gap: 16px;
  }

  @media only screen and (min-width: 967px) and (max-width: 1100px) {
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
`;
const ContImg = styled.div`
  display: flex;
  display: flex;
  position: relative;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 767px) and (max-width: 1100px) {
    align-items: center;
  }
`;

const Text3 = styled.span`
color:#003049;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 18px;
margin-bottom:30px;
`

const Text2 = styled.span`
color:#003049;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 12px;
margin-bottom:16px;
align-self: end;
`

const Text1 = styled.span`
color:#003049;
font-family: 'Montserrat', sans-serif;
font-weight: 700;
font-size: 22px;
margin-bottom:30px;
`
const LineaDivisoria = styled.div`
height:2px;
width:-webkit-fill-available;
background-color:#7f7f7f;
`

const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: calc(100vh - 31vh) !important;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
border-top: 2px solid #003049;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;
const BtnCrearAsesor = styled.div`
  width:140px;
  margin:0px 0px;
  height:30px;
  border-radius:8px;
  background-color:#003049;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  color:#ffffff;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor:pointer;
  align-self: end;
  &:hover{
    background-color:#006295;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 11px;
// color: #07082c;
`;

const FormGroup = styled.div`
  // margin-bottom: 20px;
  display:flex;
  flex-direction: column;
  gap:8px;
//   border:solid 1px red;
min-height:75px;
flex-grow:1;
flex-basis:200px
`;
const Label = styled.label`
font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 14px;
color: #07082c;
`;
const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  min-height: 20px;
  font-family: 'Montserrat', sans-serif;
font-weight: 400;
font-size: 14px;
`;
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const TextSpan = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
max-width:100px;
overflow-x: scroll;
&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}
`;
const CalendarIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  
`;

const BotonCalendar = styled.div`
// background-color: #f8f9fa;

border-radius: 100%;
border-color: #dadce0;
box-shadow: 
      0px 3.200000047683716px 7.199999809265137px 0px rgba(0, 48, 72, 0.12), 
      0px 0.6000000238418579px 1.7999999523162842px 0px rgba(0, 48, 72, 0.10);
cursor: pointer;
height: 30px;
margin: 0px 16px 0px 16px;
width: -webkit-fill-available;
align-self: center;
align-content: center;
width: 25px;
gap:8px;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #07082c;
  padding:4px 8px;
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.9);
    transform:scale(0.90)
  }
`;

const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.dni === prop.contact.dni ? '#FFFFFF' : '#07082c'}  ;



`;
const ContentFormGrid = styled.div`
display:flex;
flex-wrap:wrap;
gap: 8px;
box-sizing: border-box;
width: -webkit-fill-available;
`;

const DivColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 40vw;
    margin: 0px 0% 0% 0%;
    padding: 16px 16px;
    border-radius: 8px;
    background-color: #FFFFFF;
    gap: 0px;
    // min-height: 90vh;
    heigth: auto;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
    @media only screen and (min-width:0px) and (max-width:1100px){
      width:100%;
      min-height:95vh;
      margin-top:5vh;

      padding: 10px 16px 50px 16px;
      box-sizing: border-box;
    }
`;


const IconItem = styled.img`
width:24px;
height:24px;
min-height:24px;
min-width:24px;
padding:5px;
border-radius:50%;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
cursor:pointer;
&:hover{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
&:active{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
`;
